<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Steps",
  emits: ["goto-page"],
  props: {
    items: Array,
    active: Number,
  },
  setup(props, { emit }) {
    const gotoPage = (item: any, index: number) => {
      if (styleClass(index) == "check") {
        emit("goto-page", { pageIndex: index });
      }
    };

    const styleClass = (index: number): string => {
      if (props.active !== undefined) {
        if (index == props.active) {
          return "active";
        } else if (index < props.active) {
          return "check";
        } else {
          return "disabled";
        }
      }

      return "";
    };

    return {
      gotoPage,
      styleClass,
    };
  },
});
</script>

<template>
  <section class="section-steps" v-if="items" style="padding-bottom: 10px">
    <div class="o-grid o-grid--align-center" aria-label="Schritte" aria-hidden="true">
      <ul class="u-remove-list-styles">
        <li v-for="(item, index) in items" :key="index">
          <template v-if="item.label">
            <a tabindex="-1" :class="styleClass(index)" @click="gotoPage(item, index)">
              <span class="u-round-number" v-html="index + 1" />
              <span class="link-text" v-html="item.label" />
            </a>
          </template>
        </li>
      </ul>
    </div>
  </section>
</template>
